module.exports = __webpack_public_path__ + "media/images/sp/stores/nara/nara_concept_02-429d2f4c799509bb7a31488ff3b34f37.jpg";